import { useQuery as r } from "@tanstack/vue-query";
const t = ["dictionary"], y = 1e3, u = 60, o = 60, i = y * u * o, n = {
  all: t,
  /** Query key for mode-aware countries (flat vs full with regions). */
  countries: (e) => [...t, "countries", e],
  os: (e) => [...t, "os", e],
  deviceTypes: () => [...t, "deviceTypes"],
  browserTypes: () => [...t, "browserTypes"],
  languages: () => [...t, "languages"],
  adUnitTypes: (e) => [...t, "adUnitTypes", e],
  categories: () => [...t, "categories"],
  dealTypes: () => [...t, "dealTypes"],
  contentTypes: () => [...t, "contentTypes"],
  cpaAutoRules: () => [...t, "cpaAutoRules"],
  blacklistStatuses: () => [...t, "blacklistStatuses"],
  blacklistBanTypes: () => [...t, "blacklistBanTypes"],
  blacklistConditionParams: () => [...t, "blacklistConditionParams"],
  adUnitOwners: () => [...t, "adUnitOwners"],
  adUnitSites: () => [...t, "adUnitSites"],
  advertisers: () => [...t, "advertisers"],
  ssps: () => [...t, "ssps"],
  adTags: () => [...t, "adTags"],
  bannerSizes: () => [...t, "bannerSizes"]
}, l = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.deviceTypes(),
  queryFn: () => e.dictionary.getDeviceTypes({})
}), T = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.browserTypes(),
  queryFn: () => e.dictionary.getBrowserTypes({})
}), d = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.languages(),
  queryFn: () => e.dictionary.getLanguages({})
}), p = (e, s = "full", a) => r({
  staleTime: i,
  ...a,
  queryKey: n.adUnitTypes(s),
  queryFn: () => e.dictionary.getAdUnitTypes({ mode: s })
}), g = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.categories(),
  queryFn: () => e.dictionary.getCategories({})
}), q = (e, s = "full", a) => r({
  staleTime: i,
  ...a,
  queryKey: n.countries(s),
  queryFn: () => e.dictionary.getCountries({ mode: s })
}), S = async (e, s) => {
  await e.prefetchQuery({
    queryKey: n.countries("full"),
    queryFn: async () => s.dictionary.getCountries({ mode: "full" })
  });
}, m = (e, s = "full", a) => r({
  staleTime: i,
  ...a,
  queryKey: n.os(s),
  queryFn: () => e.dictionary.getOperatingSystems({ mode: s })
}), K = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.dealTypes(),
  queryFn: () => e.dictionary.getDealTypes({})
}), C = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.contentTypes(),
  queryFn: () => e.dictionary.getContentTypes({})
}), F = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.cpaAutoRules(),
  queryFn: () => e.dictionary.getCpaAutoRules({})
}), A = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.blacklistStatuses(),
  queryFn: () => e.dictionary.getBlacklistStatuses({})
}), U = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.blacklistBanTypes(),
  queryFn: () => e.dictionary.getBlacklistBanTypes({})
}), B = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.blacklistConditionParams(),
  queryFn: () => e.dictionary.getBlacklistConditionParams({})
}), b = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.adUnitOwners(),
  queryFn: () => e.dictionary.getAdUnitOwners({})
}), k = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.advertisers(),
  queryFn: () => e.dictionary.getAdvertisers({})
}), O = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.adUnitSites(),
  queryFn: () => e.dictionary.getAdUnitSites({})
}), I = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.ssps(),
  queryFn: () => e.dictionary.getSsps({})
}), w = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.adTags(),
  queryFn: () => e.dictionary.getAdTags({})
}), v = (e, s) => r({
  staleTime: i,
  ...s,
  queryKey: n.bannerSizes(),
  queryFn: () => e.dictionary.getBannerSizes({})
});
export {
  n as dictionaryKeys,
  S as prefetchCountriesTree,
  w as useAdTags,
  b as useAdUnitOwners,
  O as useAdUnitSites,
  p as useAdUnitTypes,
  k as useAdvertisers,
  v as useBannerSizes,
  U as useBlacklistBanTypes,
  B as useBlacklistConditionParams,
  A as useBlacklistStatuses,
  T as useBrowserTypes,
  g as useCategories,
  C as useContentTypes,
  q as useCountries,
  F as useCpaAutoRules,
  K as useDealTypes,
  l as useDeviceTypes,
  d as useLanguages,
  m as useOperatingSystems,
  I as useSsps
};
//# sourceMappingURL=queries.js.map
